import { TwoColumnLayout } from 'layouts';
import type { Event } from 'models';
import { EventDetailCountdown } from '../../components';
import { PublicEventHeader } from '../../public-event-header';
import { EventJoinStatusAlerts } from './event-join-status-alerts';

type P = {
  event: Event;
};

const PublicEventContent = ({ event }: P) => (
  <>
    <PublicEventHeader event={event} />
    <TwoColumnLayout
      left={<EventJoinStatusAlerts event={event} />}
      right={<EventDetailCountdown startTime={event.startTime} />}
    />
  </>
);

export default PublicEventContent;
